import { lazy, Suspense } from 'react'
import { Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import MicrofrontendErrorBoundary from './MicrofrontendErrorBoundary'
import Center from '../../components/layout/Center'
import Link from '../../domain/entity/Link'

export type LearningUnitEditorWrapperProps = {
  entityId: string
  entityLinks: Array<Link>
  linkKeyFromString: (key: string) => unknown
  onRegisterPartialSubmit: (fn: () => Promise<Link[]>) => void
  mode?: 'edit' | 'view'
}

const LearningUnitEditor = lazy(
  // @ts-ignore
  async () => import('eidu-remotes/dpl/learning-unit-editor')
)

const ErrorFallback = () => (
  <Center sx={{ minHeight: '200px', backgroundColor: '#f5f5f5' }}>
    <ErrorOutlineIcon color="error" sx={{ fontSize: 40 }} />
    <Typography>Learning Unit Editor Unavailable</Typography>
  </Center>
)

const LearningUnitEditorWrapper = (props: LearningUnitEditorWrapperProps) => {
  return (
    <MicrofrontendErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={null}>
        <LearningUnitEditor {...props} />
      </Suspense>
    </MicrofrontendErrorBoundary>
  )
}

export default LearningUnitEditorWrapper
